<template>
  <div>
    <error-page-with-header
      :errorName="errorName"
      :errorDescription="errorDescription"
      :logoUrl="logoUrl"
    ></error-page-with-header>
  </div>
</template>

<script>
import ErrorPageWithHeader from "@/components/ErrorPageWithHeader";
import logoUrl from "../assets/image/error_pages/401.png";
export default {
  components: {
    ErrorPageWithHeader
  },
  data() {
    return {
      errorName: "Forbidden",
      errorDescription: "Sorry, you don't have access to this page.",
      logoUrl: logoUrl
    };
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Forbidden.vue